import { render, staticRenderFns } from "./ccm-matchbook-study.vue?vue&type=template&id=0008b6e8&"
import script from "./ccm-matchbook-study.vue?vue&type=script&lang=js&"
export * from "./ccm-matchbook-study.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports